import React , { useState, useEffect } from 'react'
import config from '../config';


function Footer() {
    const [currentYear, setCurrentYear] = useState(new Date().getFullYear());

    useEffect(() => {
        const intervalId = setInterval(() => {
            setCurrentYear(new Date().getFullYear());
        }, 1000 * 60); // Update every minute to handle cases where the year changes while the user is on the page
        
        return () => clearInterval(intervalId); // Cleanup function
    }, []);
  return (
    <div>
        <footer class="site-footer">
            <div class="site-footer__shape-1 float-bob-y">
                <img src="assets/images/shapes/site-footer-shape-1.png" alt="" />
            </div>
            <div class="site-footer__top">
                <div class="container">
                    <div class="site-footer__top-inner">
                        <div class="site-footer__top-left">
                            <div class="site-footer__top-icon">
                                <span class="icon-business-people"></span>
                            </div>
                            <div class="site-footer__top-content">
                                <h3>Operating Hours: <span> <br/>Monday – Friday: 9:00 AM – 4:30 PM<br />
                                Saturday (1st, 3rd, 5th): 9:00AM – 2:45PM <br/>Sunday: Closed</span></h3>
                            </div>
                        </div>
                        <div class="site-footer__top-right">
                            <div class="site-footer__social-shape-1 float-bob-y">
                                <img src="assets/images/shapes/site-footer-social-shape.png" alt="" class="zoom-fade" />
                            </div>
                            <div class="site-footer__social-title">
                                <p>Follow on:</p>
                            </div>
                            <div class="site-footer__social">
                                <a href="https://youtube.com/@rhca-india?si=Pu2jro4V4E-xB_l_" target='_blank'  rel="noopener noreferrer"><i class="fab fa-youtube"></i></a>
                                <a href="https://www.facebook.com/rayofhopeACA?mibextid=rS40aB7S9Ucbxw6v" target='_blank'  rel="noopener noreferrer"><i class="fab fa-facebook"></i></a>
                                <a href="https://www.linkedin.com/company/ray-of-hope-center-for-autism/" target='_blank'  rel="noopener noreferrer"><i class="fab fa-linkedin"></i></a>
                                <a href="https://www.instagram.com/rhcahosur?igsh=dmV5ZHA2czhsNWlv" target='_blank'  rel="noopener noreferrer"><i class="fab fa-instagram"></i></a>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div class="container">
                <div class="site-footer__middle">
                    <div class="row">
                        <div class="col-xl-4 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="100ms">
                            <div class="footer-widget__column footer-widget__about">
                                <div class="footer-widget__logo">
                                    <a href="/"><img src={`${config.baseUrl}/assets/images/rohlogo.png`} alt="" width="50%" /></a>
                                </div>
                                <p class="footer-widget__about-text">Ray of Hope Centre for Autism</p>
                            </div>
                        </div>
                        <div class="col-xl-3 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="200ms">
                            <div class="footer-widget__column footer-widget__link">
                                <div class="footer-widget__title-box">
                                    <h3 class="footer-widget__title">Explore</h3>
                                </div>
                                <ul class="footer-widget__link-list list-unstyled">
                                    <li><a href="/">Home</a></li>
                                    <li><a href="/about-us">About Us</a></li>
                                    <li><a href="/applied-behavioral-analysis">Departments</a></li>
                                    <li><a href="/early-intervention-program">Programs</a></li>
                                    <li><a href="/our-team">Our Team</a></li>
                                    {/* <li><a href="faq.html">Beyond Therapy</a></li> */}
                                    <li><a href="/faq">FAQs</a></li>
                                </ul>
                            </div>
                        </div>
                        <div class="col-xl-5 col-lg-6 col-md-6 wow fadeInUp" data-wow-delay="300ms">
                            <div class="footer-widget__column footer-widget__Contact">
                                <div class="footer-widget__title-box">
                                    <h3 class="footer-widget__title">Contact</h3>
                                </div>
                                <ul class="footer-widget__Contact-list list-unstyled">
                                    <li>
                                        <div class="icon">
                                            <span class="fas fa-map-marker"></span>
                                        </div>
                                        <div class="text">
                                            <span>Visit Office</span>
                                            <p>Asian Christian Academy,Jeemangalam, Bagalur (P.O), Hosur, Krishnagiri (Dist.), Tamil Nadu - 635103, India.</p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="icon">
                                            <span class="fas fa-envelope"></span>
                                        </div>
                                        <div class="text">
                                            <span>Send Email</span>
                                            <p><a href="mailto:rayofhope@acaindia.org">rayofhope@acaindia.org</a></p>
                                        </div>
                                    </li>
                                    <li>
                                        <div class="icon">
                                            <span class="fas fa-phone-square"></span>
                                        </div>
                                        <div class="text">
                                            <span>Call Anytime</span>
                                            <p><a href="tel:04344255800,878">04344 - 255800 (Ext. 878)</a></p>
                                        </div>
                                    </li>
                                </ul>
                            </div>
                        </div>
                       
                    </div>
                </div>
            </div>
            <div class="site-footer__bottom">
                <div class="container">
                    <div class="row">
                        <div class="col-xl-12">
                            <div class="site-footer__bottom-inner">
                                <p class="site-footer__bottom-text">© Copyright <span className="dynamic-year">{currentYear}</span> Ray of Hope Centre for Autism.All Rights Reserved. <a href='/terms-and-conditions'> Privacy Policy | Terms & Conditions</a>. Powered By <a href='https://media-aca.org/'  target='_blank'  rel="noopener noreferrer"> ACA Media</a></p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </footer>
    </div>
  )
}

export default Footer